import React, { useState, useEffect, lazy, Suspense, Fragment } from "react";
import ExecutionEnvironment from "exenv";
import PropTypes from "prop-types";
import axios from "axios";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
import StaticProfile from "../components/Profile/StaticProfile";

// MUI stuff
import Grid from "@mui/material/Grid";
import { makeStyles } from "tss-react/mui";
import { Typography } from "@mui/material";

// Redux stuff
import { connect } from "react-redux";

const useStyles = makeStyles()(() => ({
  profileAndPosts: {
    maxWidth: 1200,
    marginTop: 10,
    margin: "auto",
  },
  infoText: {
    color: "white",
  },
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function User(props) {
  const [profile, setProfile] = useState(null);
  const { loading } = props.data;
  const { handle, postId } = props.match.params;

  const { classes } = useStyles();

  useEffect(() => {
    axios
      .get(`/api/user/${handle}`)
      .then((res) => {
        setProfile(res.data.user);
      })
      .catch((err) => console.error(err));
  }, [handle]);

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`User - Content Generator`}
        description={`Discover and connect with successful social media marketers in our community. Browse user profiles, learn from their strategies, and network with professionals who are growing their presence on social media.`}
        url={`https://contentgenerator.io/users`}
      />
      <Grid
        container
        spacing={2}
        className={classes.profileAndPosts}
        justifyContent="center"
      >
        <Grid item sm={6} xs={12}>
          {}
        </Grid>
        <Grid item sm={4} xs={12}>
          {profile === null ? (
            <Typography className={classes.infoText}>
              Loading profile...
            </Typography>
          ) : (
            ExecutionEnvironment.canUseDOM && (
              <Fragment>
                <Suspense fallback={<div />}>
                  <StaticProfile profile={profile} />
                </Suspense>
              </Fragment>
            )
          )}
        </Grid>
      </Grid>
    </div>
  );
}

User.propTypes = {
  data: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  data: state.data,
});

export default connect(mapStateToProps)(User);
